import React, { useState, useContext } from 'react';

import { observer } from 'mobx-react-lite';

import Button from 'components/common/Button/Button';
import { MailIcon } from 'components/common/Icons/Icons';
import { notify } from 'components/common/Toast/toast.helpers';
import { RootStoreContext } from 'index';
import { ToastMessage } from 'components/common/Toast/toast.enums';
import SideBar from 'components/common/SideBar/SideBar';

import styles from './ContactHfsDialog.module.scss';
import { ValidateContactHfsFormResult } from './contactHfsDialog.types';
import ContactHfs from './ContactHfs';
import Tooltip from '../../common/Tooltip/Tooltip';

const ContactHfsDialog = () => {
  const [open, setOpen] = useState(false);
  const { intermediaryStore } = useContext(RootStoreContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (values: ValidateContactHfsFormResult) => {
    try {
      await intermediaryStore.contactHfs(values);
      setOpen(false);

      notify(ToastMessage.EmailSent, 'success');
    } catch (error: any) {
      notify(error.message, 'error');
    }
  };

  return (
    <>
      <Button className={styles.mailButton} onClick={handleClickOpen} variant={'link'}>
        <Tooltip title="Contact HFS" placement="bottom">
          <div>
            <MailIcon className={styles.mailIcon} />
          </div>
        </Tooltip>
      </Button>
      <SideBar title="Contact HFS" isOpen={open} onClose={handleClose}>
        <ContactHfs onSubmit={handleSubmit} />
      </SideBar>
    </>
  );
};

export default observer(ContactHfsDialog);
